export const defaultLocale = 'en' as const
export const locales = ['en', 'nl'] as const
export type Locale = (typeof locales)[number]

export const localeNames: Record<Locale, string> = {
    en: 'English',
    nl: 'Nederlands'
}

export function isValidLocale(locale: string): locale is Locale {
    return locales.includes(locale as Locale)
}

export const LOCALE_COOKIE_NAME = 'zentjes-locale'

export const marketingRoutes = [
    '/',
    '/privacy',
    '/terms',
    '/developers',
    '/changelog'
] as const
